export function apiBase() {
  const url = process.env.VITE_APP_WEBAPI.replace('/graphql', ``);
  return url;
}
